import * as helpers from '../helpers';

export default class Tooltip {
    constructor(selector = '.js-tooltip', options = {}) {
        this.selector = selector;
        this.tooltipElement = null;
        this.timeOut = null;
        this.elements = [];

        // Plugin options
        this.options = {
            // set the side (top/bottom)
            side: 'top',
            // set the placement (center/start/end)
            placement: 'center',
            // sets the indents around tooltip
            indents: 10,
            // display delay
            delay: 200,
        };

        this.$showTooltip = this.showTooltip.bind(this);
        this.$hideTooltip = this.hideTooltip.bind(this);

        this.init();
    }

    init() {
        this.elements = [...document.querySelectorAll(this.selector)];

        this.elements = this.elements.filter((element) => {
            return !element.getAttribute('data-content');
        });

        if (!this.elements.length) {
            return;
        }

        this.addHandler();
        this.createTooltip();
    }

    createTooltip() {
        this.tooltipElement = document.createElement('div');
        this.tooltipElement.id = 'access-tooltip';
        this.tooltipElement.style.opacity = '0';
        this.tooltipElement.style.display = 'none';
        document.body.appendChild(this.tooltipElement);
    }

    addHandler() {
        [...this.elements].forEach((item) => {
            if (item.hasAttribute('title')) {
                item.setAttribute('data-content', item.getAttribute('title'));
                item.removeAttribute('title');

                ['mouseover', 'focus'].forEach((eventType) => {
                    item.addEventListener(eventType, this.$showTooltip, false);
                });

                ['mouseout', 'blur'].forEach((eventType) => {
                    item.addEventListener(eventType, this.$hideTooltip, false);
                });
            }
        });

        window.addEventListener('scroll', () => {
            this.hideTooltip();
        });
    }

    showTooltip(event) {
        const target = event.target;

        if (helpers.hasClass(target, 'js-tooltip')) {
            this.tooltipElement.style.display = 'block';
            this.tooltipElement.innerText = target.getAttribute('data-content');
            this.positionTooltip(target, this.tooltipElement);

            this.timeOut = setTimeout(() => {
                this.tooltipElement.style.opacity = '1';
            }, this.options.delay);
        }
    }

    hideTooltip() {
        this.timeOut = clearTimeout(this.timeOut);
        this.tooltipElement.style.opacity = '0';
        this.tooltipElement.style.display = 'none';
    }

    getCoords(elem) {
        const box = elem.getBoundingClientRect();

        return {
            top: box.top + pageYOffset,
            bottom: box.bottom + pageYOffset,
            left: box.left + pageXOffset,
            right: box.right + pageXOffset,
        };
    }

    positionTooltip(item, tooltipElem) {
        tooltipElem.style.left = 0;
        tooltipElem.style.top = 0;
        const itemCoords = this.getCoords(item);
        const windowWidth = document.body.clientWidth;
        const windowHeight = document.body.clientHeight;

        switch (this.options.placement) {
            case 'center':
                tooltipElem.style.left = `${itemCoords.left + (item.offsetWidth - tooltipElem.offsetWidth) / 2}px`;
                break;
            case 'from-center':
                tooltipElem.style.left = `${itemCoords.left + (item.offsetWidth / 2)}px`;
                break;
            case 'start':
                tooltipElem.style.left = `${itemCoords.left}px`;
                break;
            case 'end':
                tooltipElem.style.left = `${itemCoords.right - tooltipElem.offsetWidth}px`;
                break;
            default:
                tooltipElem.style.left = `${itemCoords.left + (item.offsetWidth - tooltipElem.offsetWidth) / 2}px`;
                break;
        }

        switch (this.options.side) {
            case 'top':
                tooltipElem.style.top = `${itemCoords.top - tooltipElem.offsetHeight - +this.options.indents}px`;
                break;
            case 'bottom':
                tooltipElem.style.top = `${itemCoords.bottom + +this.options.indents}px`;
                break;
            default:
                tooltipElem.style.top = `${itemCoords.bottom + +this.options.indents}px`;
                break;
        }

        const tooltipCoords = this.getCoords(tooltipElem);
        const styleElem = document.head.appendChild(document.createElement('style'));
        if (itemCoords.left - tooltipCoords.left > 0) {
            styleElem.innerHTML = `#access-tooltip:before {left: ${Math.abs((itemCoords.left - tooltipCoords.left)) + (item.offsetWidth / 2)}px;}`;
        } else {
            styleElem.innerHTML = '#access-tooltip:before {left: 50%}';
        }

        if (tooltipCoords.bottom > windowHeight) {
            tooltipElem.style.top = `${itemCoords.top - tooltipElem.offsetHeight - +this.options.indents}px`;
        }
        if (tooltipCoords.top < 0) {
            tooltipElem.style.top = `${itemCoords.bottom + +this.options.indents}px`;
        }
        if (tooltipCoords.right > windowWidth) {
            tooltipElem.style.left = `${windowWidth - tooltipElem.offsetWidth}px`;
        }
        if (tooltipCoords.left < 0) {
            styleElem.innerHTML = `#access-tooltip:before {left: ${Math.abs((itemCoords.left - 0)) + (item.offsetWidth / 2)}px;}`;
            tooltipElem.style.left = 0;
        }
    }

    static setDataContent(item, content) {
        if (item.hasAttribute('data-content')) {
            item.setAttribute('data-content', content);
        }
    }
}
